<template>
  <section class="selftests">

      <div class="tab">
        <span
            v-if="$store.getters.getPermissions?.viewDeviceSelftestResults === true"
            class="tab_title"
            :class="{ active : block==='SelfTestList'}"
            @click="selected_block('SelfTestList')"
        >
          {{translate('selftest_list')}}
        </span>

        <span
            v-if="$store.getters.getPermissions?.viewDeviceSnapshot === true"
            class="tab_title"
            :class="{ active : block==='SnapshotsList'}"
            @click="selected_block('SnapshotsList')"
        >
          {{translate('snapshot.list')}}
        </span>

        <span
            v-if="$store.getters.getPermissions?.viewDeviceFactoryTest === true"
            class="tab_title"
            :class="{ active : block==='FactoryTestList'}"
            @click="selected_block('FactoryTestList')"
        >
          {{translate('factorytest_list.title')}}
        </span>
      </div>
      <div class="block">
        <SelfTestsList
            v-if="block==='SelfTestList' && $store.getters.getPermissions?.viewDeviceSelftestResults === true"
            :device_id="profile.id"
        />
        <SnapshotsList
            v-if="block==='SnapshotsList' && $store.getters.getPermissions?.viewDeviceSnapshot === true"
            :profile="profile"
        />
        <FactoryTestList
            v-if="block==='FactoryTestList' && $store.getters.getPermissions?.viewDeviceFactoryTest === true"
            :device_id="profile.id"
        />
      </div>

  </section>
</template>

<script>
import SelfTestsList from "./Tabs/SelfTestList/Index.vue"
import FactoryTestList from "./Tabs/FactoryTestList/Index.vue"
import SnapshotsList from "./Tabs/SnapshotList/Index.vue"

export default {
  name: 'SelfTests',
  components: {
    SelfTestsList,
    FactoryTestList,
    SnapshotsList
  },
  props: ['profile'],

  data(){
    return {
      block: '',
    }
  },
  created() {
    this.check_query()
  },
  methods: {
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        if (this.$route.query.block){
          this.block = this.$route.query.block
        } else if (this.$route.query.selftest_id){
          this.block = 'SelfTestList'
        } else if (this.$route.query.snapshot_id){
          this.block = 'SnapshotsList'
        } else if (this.$route.query.factorytest_id){
          this.block = 'FactoryTestList'
        }
      } else {
        if (this.$store.getters.getPermissions?.viewDeviceSelftestResults === true){
          this.block = 'SelfTestList'
        }else if (this.$store.getters.getPermissions?.viewDeviceSnapshot === true){
          this.block = 'SnapshotsList'
        }else if (this.$store.getters.getPermissions?.viewDeviceFactoryTest === true){
          this.block = 'FactoryTestList'
        }
      }
    },
    selected_block(block){
      this.block = block

      // let string = '?'
      // string += `&block=${block}`
      // history.pushState(null, null, this.$route.path + string)
    },
  }
}
</script>

<style lang="scss" scoped>
.selftests{
  height: 100%;
  padding-top: 10px;
  .tab{
    width: 100%;
    height: 5%;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: row;
    padding-top: 0;
    &_title{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      background-color: #efe9e9;
      border: 1px solid #efe9e9;
      &.active{
        background-color: white;
        border-bottom: 1px solid white;
      }
    }
  }
  .block{
    height: 95%;
    border: 1px solid #efe9e9;
    margin-top: -1px;
    padding: 10px;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }
}
</style>
